import {writable} from 'svelte/store';

let locationObject = {
    list: null,
};

const {get, set, update, subscribe} = writable(locationObject);

const location$ = {
    set,
    update,
    subscribe,

}


export default location$;